export default (props, { colors, rhythm, scale }) => {
  return {
    root: {
      fontSize: scale(-0.5),
      borderBottom: `1px solid ${colors.shade}`,
      textAlign: 'left'
    },

    donation: {
      padding: `${rhythm(0.5)} ${rhythm(1)}`
    },

    amount: {
      fontWeight: 700,
      color: colors.secondary,
      whiteSpace: 'nowrap'
    },

    reply: {
      position: 'relative',
      padding: `${rhythm(0.5)} ${rhythm(1)}`,
      backgroundColor: colors.shade,

      ':before': {
        content: '',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: '3px',
        backgroundColor: colors.primary
      }
    },

    replyLabel: {
      color: colors.grey,
      fontSize: scale(-1),
      marginBottom: rhythm(0.25)
    },

    replyContent: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: rhythm(0.15)
    },

    editIcon: {
      color: colors.grey,
      cursor: 'pointer',
      fontSize: '0.9em',
      ':hover': {
        color: colors.primary
      }
    },

    loadMoreContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: rhythm(0.5)
    },

    loadMoreButton: {
      color: colors.primary,
      cursor: 'pointer'
    }
  }
}
